import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {GameCenterContainerConfig} from "./game-center-container.config";
import {GameCenterContainerHandlers} from "./handlers/game-center-container.handlers";
import {GameCenterContainerStore} from "./game-center-container.store";

export class GameCenterContainerController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, GameCenterContainerConfig, GameCenterContainerStore, GameCenterContainerHandlers];
}